import debounce from 'lodash/debounce';
import { useEffect, useMemo, useRef } from 'react';

export function useDebouncedCallback<A extends unknown[]>(callback: (...args: A) => void, wait: number) {
  const callbackRef = useRef(callback);
  callbackRef.current = callback;

  const debounced = useMemo(() => debounce((...args: A) => callbackRef.current(...args), wait), [wait]);

  useEffect(() => () => debounced.cancel(), [debounced]);

  return debounced;
}
